// Central source of truth for theme-related media assets.
// Shared by <HeroSection /> (renders the background) and <ThemeTransition />
// (preloads assets + picks the correct transition video), keeping things DRY.

/** Full-bleed hero background image for each theme. */
export const THEME_BACKGROUNDS = {
  dark: "/dn_bg.jpg",
  light: "/hero-light.jpg",
} as const;

/**
 * Cinematic transition videos, named by the direction of travel:
 *  - `toDark`:  played when switching light -> dark
 *  - `toLight`: played when switching dark  -> light
 * Each provides a WebM (VP9) source (preferred: small + widely supported in
 * Chrome/Firefox/Edge) and an H.264 MP4 fallback (Safari / older browsers).
 * The last frame of each clip is designed to visually align with the
 * corresponding target background for a seamless reveal.
 */
export const TRANSITION_VIDEOS = {
  toDark: {
    webm: "/videos/light-to-dark-transition.webm",
    mp4: "/videos/light-to-dark-transition.mp4",
  },
  toLight: {
    webm: "/videos/dark-to-light-transition.webm",
    mp4: "/videos/dark-to-light-transition.mp4",
  },
} as const;

/**
 * Safety timeout (ms). If a transition video never fires `onEnded`
 * (stall, codec issue, tab throttling, etc.) we force-commit the theme
 * after this window so the UI can never get stuck behind the overlay.
 * Videos are ~6s, so we allow a small buffer.
 */
export const TRANSITION_FALLBACK_TIMEOUT_MS = 9000;


/**
 * How much the header + hero content (title, buttons, stats) are dimmed while
 * the cinematic transition video plays. 0 = fully invisible, 1 = fully visible.
 * ⬇️ EDIT THIS SINGLE VALUE to make the content more/less visible during the video.
 */
export const HERO_DIM_OPACITY = 0.40;
